import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as Yup from "yup";
import {
  Card,
  CardBody,
  Col,
  Row,
  ModalHeader
} from "reactstrap";
import {
  getInitValueArray,
  getInitValue,
  intToDateFormat,
  getInvalid,
} from "components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";

import "toastr/build/toastr.min.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { withTranslation } from "react-i18next";
import { getPayOutStatusDefList, getMerchantPaymentFileSearch, getMerchantPaymentFileList } from "store/actions";
import RavenFormikField from "components/Common/RavenFormikField";

class SearchContentMerchantPaymentFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      record: "",
      recordList: [],
      filterSelected: "",
    };

  };
  handleSearch = values => {
    const { onGetMerchantPaymentFileSearch } = this.props;
    onGetMerchantPaymentFileSearch(values);
  };

  render() {
    const { filterSelected } = this.state;
    return (
      <Row>
        <Col xs="12">
          <Card>
            <CardBody>
              <Formik
                enableReinitialize={true}
                disabled={true}
                initialValues={{
                  PaymentDateStartDate: intToDateFormat(
                    filterSelected,
                    filterSelected.PaymentDateStartDate,
                  ),
                  PaymentDateEndDate: intToDateFormat(
                    filterSelected,
                    filterSelected.PaymentDateEndDate,
                  ),
                  payOutStatusGuid: getInitValue(filterSelected, filterSelected.payOutStatusGuid),
                  userName: localStorage.getItem("username"),
                }}
                validationSchema={Yup.object().shape({
                  PaymentDateStartDate: Yup.date().required(this.props.t("mustBe")),
                  PaymentDateEndDate: Yup.date().required(this.props.t("mustBe"))
                })}
                onSubmit={values => {
                  if (values.PaymentDateStartDate == "") {
                    let todayDate = new Date();
                    let before30Day = new Date();
                    before30Day.setDate(todayDate.getDate());
                    let before30DayStr = before30Day.toISOString().split('T')[0];
                    values.PaymentDateStartDate = before30DayStr;
                  }

                  if (values.PaymentDateEndDate == "") {
                    let todayDate = new Date();
                    let before30Day = new Date();
                    before30Day.setDate(todayDate.getDate() - 30);
                    let before30DayStr = before30Day.toISOString().split('T')[0];
                    values.PaymentDateEndDate = before30DayStr;
                  }
                  values.userName = localStorage.getItem("username");
                  if (values.payOutStatusGuid == undefined ||values.payOutStatusGuid == "")
                    values.payOutStatusGuid = null;
                  this.handleSearch(values);
                }}
              >
                {({ errors, touched }) => (
                  <Form>
                    <Row>
                    </Row>
                    <Row>
                      <Col lg={12} className="col-12">
                        <div className="mb-3">
                          <details open={true}>
                            <summary>
                              {this.props.t("paymentDate")}
                            </summary>

                            <Row>
                              <Col lg={6} className="col-7">
                                <Field
                                  name="PaymentDateStartDate"
                                  className={"form-control" + getInvalid(errors.PaymentDateStartDate, touched.PaymentDateStartDate)}
                                  type="date"
                                />
                                 <ErrorMessage
                                    name="PaymentDateStartDate"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                              </Col>
                              <Col lg={6} className="col-7">
                                <Field
                                  name="PaymentDateEndDate"
                                  className={"form-control" + getInvalid(errors.PaymentDateEndDate, touched.PaymentDateEndDate)}
                                  type="date"
                                />
                                  <ErrorMessage
                                    name="PaymentDateEndDate"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                              </Col>
                            </Row>

                          </details>
                        </div>
                      </Col>
                    </Row>
                    <Row>

                    </Row>
                    <Row>
                      <Col lg={12} className="col-12">
                        <div className="mb-3">
                          <details open={true}>
                            <summary>
                              {this.props.t("payOutStatus")}
                            </summary>
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"payOutStatusGuid"}
                              label={""}
                              component="multiselect"
                              type="singleselect"
                              valueList={this.props.payOutStatusRecordList}
                              nameOnValueList={"description"}
                            />
                          </details>
                        </div>
                      </Col>
                    </Row>
                    <ModalHeader
                      style={{ marginBottom: "10px" }}
                    ></ModalHeader>
                    <Row>
                      <Col lg={10}>
                        <div style={{ textAlign: "right" }}>
                          <button
                            type="submit"
                            className="btn btn-success save-event"
                            style={{ marginRight: "3px" }}
                          >
                            {this.props.t("search")}
                          </button>

                          <button
                            type="reset"
                            className="btn btn-secondary save-customer"
                          >
                            {this.props.t("clear")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}
SearchContentMerchantPaymentFile.propTypes = {
  onGetMerchantPaymentFileSearch: PropTypes.func,
  t: PropTypes.any,
  onGetPayOutStatusList: PropTypes.func,
  payOutStatusRecordList: PropTypes.array,
};

const mapStateToProps = ({  payOutStatusDef }) => ({
  payOutStatusRecordList: payOutStatusDef.recordList,
});

const mapDispatchToProps = dispatch => ({
  onGetMerchantPaymentFileSearch: filterSelected =>
    dispatch(getMerchantPaymentFileSearch(filterSelected)),
  onGetPayOutStatusList: () => dispatch(getPayOutStatusDefList()),
  onGetRecordList: () => dispatch(getMerchantPaymentFileList()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(SearchContentMerchantPaymentFile));